import { useState, useEffect } from 'react';
import { StoreMonitoringPage } from './seller/StoreMonitoringPage';
import { DesktopStoreMonitoringPage } from './desktop/DesktopStoreMonitoringPage';

export function ResponsiveStoreMonitoringPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <StoreMonitoringPage /> : <DesktopStoreMonitoringPage />;
}